const cloudinaryConfig = {
    cloudName: 'okuro',
    uploadPreset: 'gari_admin'
  } 
  
  export default cloudinaryConfig 
  